<template>
  <div><RetirementLanding /></div>
</template>

<script>
import RetirementLanding from '@/components/Retirement/Landing.vue'
export default {
  data() {
    return {}
  },
  name: 'RetirementLandingView',
  components: {
    RetirementLanding
  }
}
</script>